import { FilesCallback } from 'components/UploadInput';
import { sendDocumentRequest } from 'services/claimsService';
import { getPresignedPostData } from 'services/openClaimService';

export const sendFile = async (
  id: string,
  files: FilesCallback[],
  page: string,
  cpCode: any,
  franchiseCode: string,
  motive = '',
) => {
  const arrayOfPromises = files.map(async file => {
    const { data: presignedPostData } = await getPresignedPostData(
      file.file.data.name,
      cpCode,
      franchiseCode,
    );
    const reader = new FileReader();

    return new Promise(resolve => {
      reader.readAsArrayBuffer(file.file.data);
      reader.onload = () => {
        fetch(presignedPostData.response.URL, {
          method: 'PUT',
          body: reader.result,
        }).then(response => {
          if (response.status === 200) {
            resolve({
              documentId: file.idDoc,
              filename: file.file.data.name,
              id: presignedPostData.response.key,
            });
          }
        });
      };
    });
  });

  return Promise.all(arrayOfPromises).then(async results => {
    const filesSuccess = {
      files: results,
    };
    await sendDocumentRequest(
      filesSuccess,
      id,
      page,
      cpCode,
      franchiseCode,
      motive,
    );
  });
};
